import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultNoAccessUsersDataSelector,
    accountSearchResultNoAccessUsersResultSelector,
} from '../../slices/account-search-result-no-access-users.slice';

type Props = {
    accountId: number,
};

export const NoAccessUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultNoAccessUsersDataSelector);
    const result = useSelector(accountSearchResultNoAccessUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/no-access"
        />
    );
};
